import BenefitsPage from "./components/benefits-page";
import IntegrationPage from "./components/integration-page";
import IntroPage from "./components/intro-page";
// import SolutionsPage from "./components/solutions-page";
import WhyChatMePage from "./components/why-chat-me-page";

const Main = () => {
    return (
        <div className="flex flex-col w-full">
            <IntroPage />
            <WhyChatMePage />
            {/* Todo later */}
            {/* <SolutionsPage /> */}
            <BenefitsPage />
            <IntegrationPage />
        </div>
    )
}

export default Main;